/* CARBO_LAUNCH Bedarf – zentrale V20-Konfiguration & native Anwendungspresets */
(() => {
  'use strict';
  if (window.__tpv20CentralRuntime) return;
  window.__tpv20CentralRuntime = true;

  const CENTRAL_CONFIG = Object.freeze({
    expressCutoffHour: 10,
    pickupCutoffHour: 13,
    b2bThresholdKg: 420.2,
    b2bUrl: '/pages/trockeneis-fuer-unternehmen',
    plannerToleranceRate: 0.05,
    quickBuiltInSafetyRate: 0.08,
    detailBuiltInSafetyRate: 0.10,
    storageRates: Object.freeze({ nuggets: 0.12, pellets: 0.16, scheiben: 0.09 }),
    safetyRates: Object.freeze({ lean: 0.05, prime: 0.12, safe: 0.22 }),
    riskAllowedUsecases: Object.freeze(['events','fog','food','lab','blasting','catering','transport','camping','emergency','industry','cleaning']),
    pickupProductLocations: Object.freeze({
      scheiben: Object.freeze(['hannover'])
    }),
    productFulfillmentLocations: Object.freeze({
      scheiben: Object.freeze({ key: 'hannover', name: 'Laatzen', rule: 'Lieferung und Abholung ausschließlich über Laatzen' })
    }),
    pickupLocations: Object.freeze({
      hannover: Object.freeze({ name: 'CARBO Hannover', address: 'Meineckestraße 12-14, Laatzen, 30880, Germany' }),
      'bad-hoenningen': Object.freeze({ name: 'CARBO Bad Hönningen', address: 'Sprudelstraße 1, Bad Hönningen, 53557, Germany' }),
      nordhorn: Object.freeze({ name: 'Coditec GmbH', address: 'Enschedestraße 39, Nordhorn, 48529, Germany' })
    })
  });

  window.TPV20CentralConfig = CENTRAL_CONFIG;

  const readNodeConfig = node => {
    try {
      const parsed = JSON.parse(node?.textContent || '{}');
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (_) {
      return {};
    }
  };
  const configJson = node => JSON.stringify({ ...readNodeConfig(node), ...CENTRAL_CONFIG });
  const nodesIn = (scope, selector) => {
    const nodes = [];
    if (scope instanceof Element && scope.matches(selector)) nodes.push(scope);
    scope?.querySelectorAll?.(selector).forEach(node => nodes.push(node));
    return nodes;
  };

  const applyCentralConfig = (scope = document) => {
    nodesIn(scope, '[data-tpv20-config]').forEach(node => {
      const json = configJson(node);
      if (node.textContent.trim() !== json) node.textContent = json;
      node.dataset.tpv20Central = 'true';
    });
    nodesIn(scope, '.tp-feas').forEach(root => {
      root.dataset.cutoff = String(CENTRAL_CONFIG.expressCutoffHour);
      root.dataset.b2b = String(CENTRAL_CONFIG.b2bThresholdKg);
      root.dataset.tpv20Policy = 'central';
      root.querySelectorAll('[data-tp-feas-b2b-threshold]').forEach(node => { node.textContent = String(CENTRAL_CONFIG.b2bThresholdKg); });
      root.querySelectorAll('[data-tp-feas-cutoff]').forEach(node => { node.textContent = String(CENTRAL_CONFIG.expressCutoffHour).padStart(2, '0') + ':00'; });
    });
  };

  const ensureBestellpilotAnchor = (scope = document) => {
    const root = scope instanceof Element && scope.matches('[data-tpv20-root]')
      ? scope
      : scope?.querySelector?.('[data-tpv20-root]') || document.querySelector('[data-tpv20-root]');
    if (!root) return null;
    let anchor = document.getElementById('bestellpilot');
    if (anchor) return anchor;
    anchor = document.createElement('span');
    anchor.id = 'bestellpilot';
    anchor.setAttribute('aria-hidden', 'true');
    anchor.dataset.tpv20CentralAnchor = 'true';
    anchor.style.cssText = 'display:block;height:0;overflow:hidden;scroll-margin-top:100px';
    root.insertAdjacentElement('beforebegin', anchor);
    return anchor;
  };

  const firstLabel = article => article?.querySelector(':scope > span') || article?.querySelector('span');
  const setScenarioLabel = (button, text) => {
    const label = firstLabel(button.closest('article'));
    if (label && text) label.textContent = text;
  };

  const normalizeScenarioData = (scope = document) => {
    const groups = new Map();
    nodesIn(scope, '[data-tp-app-preset]').forEach(button => {
      const key = button.dataset.usecase || '';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(button);
    });

    (groups.get('camping') || []).forEach(button => {
      if (button.dataset.tpv20NativePreset === 'true') return;
      const count = Math.max(1, Number(button.dataset.quantity || 1));
      const volume = Math.max(5, Number(button.dataset.volume || button.dataset.quantity || 40));
      button.dataset.quantity = String(Math.round(count * volume));
      delete button.dataset.volume;
      button.dataset.tpv20NativePreset = 'true';
      if (count > 1) {
        const copy = button.closest('article')?.querySelector('p');
        if (copy) copy.textContent = `Zwei Kühlboxen mit zusammen ${Math.round(count * volume)} Litern über vier Tage.`;
      }
    });

    (groups.get('emergency') || []).forEach(button => {
      const volume = Math.max(20, Number(button.dataset.volume || button.dataset.quantity || 200));
      button.dataset.quantity = String(volume);
      delete button.dataset.volume;
      button.dataset.tpv20NativePreset = 'true';
    });

    const labVolumes = [10, 20, 40, 70];
    (groups.get('lab') || []).forEach((button, index) => {
      const volume = labVolumes[index] || 20;
      button.dataset.volume = String(volume);
      const duration = Number(button.dataset.duration || 24);
      setScenarioLabel(button, `${volume} L · ${duration} Std.`);
      button.dataset.tpv20NativePreset = 'true';
    });

    const industryRates = [5, 10, 10, 45];
    (groups.get('industry') || []).forEach((button, index) => {
      const rate = industryRates[index] || 5;
      button.dataset.consumption = String(rate);
      setScenarioLabel(button, `${Number(button.dataset.duration || 8)} Std. · ${rate} kg/h`);
      if (index === 3) {
        const copy = button.closest('article')?.querySelector('p');
        if (copy) copy.textContent = 'Sehr hoher Richtverbrauch bzw. automatisierte Oberflächenreinigung über eine Schicht.';
      }
      button.dataset.tpv20NativePreset = 'true';
    });

    const cleaningRates = [18, 45, 65, 100];
    (groups.get('cleaning') || []).forEach((button, index) => {
      const rate = cleaningRates[index] || 18;
      button.dataset.consumption = String(rate);
      setScenarioLabel(button, `${Number(button.dataset.duration || 3)} Std. · ${rate} kg/h`);
      button.dataset.tpv20NativePreset = 'true';
    });
  };

  const wait = ms => new Promise(resolve => window.setTimeout(resolve, ms));
  const nativeControl = (root, key) => key === 'usecase'
    ? root.querySelector('[data-tpv20-usecase]')
    : root.querySelector(`[data-tpv20-field="${key}"]`);

  const setNativeControl = (control, value) => {
    if (!control || value === undefined || value === null || value === '') return false;
    let wanted = String(value);
    if (control instanceof HTMLSelectElement) {
      let option = Array.from(control.options).find(item => String(item.value) === wanted);
      if (!option && Number.isFinite(Number(value))) {
        const numeric = Array.from(control.options)
          .map(item => ({ item, number: Number(item.value) }))
          .filter(entry => Number.isFinite(entry.number));
        numeric.sort((a, b) => Math.abs(a.number - Number(value)) - Math.abs(b.number - Number(value)));
        option = numeric[0]?.item || null;
      }
      if (!option) return false;
      wanted = option.value;
    }
    control.value = wanted;
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const plannerStep = root => Number(root.querySelector('[data-tpv20-planner-step]')?.dataset.tpv20PlannerStep || 0);
  const reviewVisible = root => Boolean(root.querySelector('[data-tpv20-review]:not([hidden])'));

  const ensurePlannerMode = async root => {
    const button = root.querySelector('[data-tpv20-mode="planner"]');
    if (button && button.getAttribute('aria-selected') !== 'true') {
      button.click();
      await wait(60);
    }
  };

  const goToStep = async (root, wanted) => {
    for (let attempt = 0; attempt < 5; attempt += 1) {
      if (reviewVisible(root)) return 'review';
      const current = plannerStep(root);
      if (current === wanted) return true;
      const button = current < wanted ? root.querySelector('[data-tpv20-next]') : root.querySelector('[data-tpv20-back]');
      if (!(button instanceof HTMLButtonElement) || button.disabled) return false;
      button.click();
      await wait(65);
    }
    return plannerStep(root) === wanted;
  };

  const applyApplicationPreset = async button => {
    applyCentralConfig(document);
    normalizeScenarioData(document);
    const root = document.querySelector('[data-tpv20-root]');
    if (!root) return;
    await ensurePlannerMode(root);

    if (reviewVisible(root)) {
      const usecase = nativeControl(root, 'usecase');
      if (usecase) setNativeControl(usecase, button.dataset.usecase || 'events');
      await wait(70);
      ['quantity','duration','volume','temp','consumption'].forEach(key => {
        if (button.dataset[key] !== undefined) setNativeControl(nativeControl(root, key), button.dataset[key]);
      });
    } else {
      await goToStep(root, 1);
      const usecase = nativeControl(root, 'usecase');
      if (usecase) setNativeControl(usecase, button.dataset.usecase || 'events');
      await wait(80);
      const onStepTwo = await goToStep(root, 2);
      if (onStepTwo === true) {
        ['quantity','duration'].forEach(key => {
          if (button.dataset[key] !== undefined) setNativeControl(nativeControl(root, key), button.dataset[key]);
        });
        await wait(45);
        const onStepThree = await goToStep(root, 3);
        if (onStepThree === true) {
          ['volume','temp','consumption'].forEach(key => {
            if (button.dataset[key] !== undefined) setNativeControl(nativeControl(root, key), button.dataset[key]);
          });
        }
      }
    }

    root.dataset.tpv20ApplicationPreset = button.dataset.usecase || '';
    const shell = root.closest('[data-tp-app-pilot-shell]') || root;
    shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    shell.classList.remove('tp-app-pilot-highlight--pulse');
    window.requestAnimationFrame(() => shell.classList.add('tp-app-pilot-highlight--pulse'));
    document.dispatchEvent(new CustomEvent('tpv20:preset-applied', { detail: { usecase: button.dataset.usecase || '' } }));
  };

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const button = target?.closest?.('[data-tp-app-preset]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void applyApplicationPreset(button);
  }, true);

  applyCentralConfig(document);
  normalizeScenarioData(document);
  ensureBestellpilotAnchor(document);
  document.addEventListener('shopify:section:load', event => {
    applyCentralConfig(event.target);
    normalizeScenarioData(event.target);
    ensureBestellpilotAnchor(event.target);
  });
  window.addEventListener('pageshow', () => {
    applyCentralConfig(document);
    normalizeScenarioData(document);
    ensureBestellpilotAnchor(document);
  });
})();

/* V20: kundenfreundliche Texte ohne zweiten App-Request. */
(() => {
  'use strict';
  if (window.__tpv20CustomerCopyPatch) return;
  window.__tpv20CustomerCopyPatch = true;

  const observedRoots = new WeakSet();

  const customerFriendlyPickupCopy = html => String(html || '')
    .replace(/Same-Day-Bestellungen/g, 'Bestellungen für eine Abholung am selben Tag')
    .replace(/Same-Day-Abholung/g, 'Abholung am selben Tag')
    .replace(/(\d{1,2}:\d{2})-Uhr-Cutoff/g, 'Bestellschluss um $1 Uhr')
    .replace(/Same-Day-Cutoff\s+(\d{1,2}:\d{2})\s+Uhr\s+überschritten\./g, 'Bestellschluss für Abholung am selben Tag ($1 Uhr) überschritten.')
    .replace(/\. Cutoff\s+(\d{1,2}:\d{2})\s+Uhr\./g, '. Bestellschluss $1 Uhr.');

  const patchRoot = root => {
    if (!(root instanceof Element)) return;

    root.querySelectorAll('[data-tpv20-mode="planner"]').forEach(button => {
      const textNode = Array.from(button.childNodes).find(node =>
        node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Bestellpilot'
      );
      if (textNode) textNode.textContent = 'Geführt';
      else if (button.textContent.trim() === 'Bestellpilot') button.textContent = 'Geführt';
    });

    root.querySelectorAll('[data-tpv20-live-guide]').forEach(guide => {
      const text = String(guide.textContent || '').replace(/\s+/g, ' ').trim();
      let html = customerFriendlyPickupCopy(guide.innerHTML);

      if (guide.matches('[data-tpv20-live-guide="time"]')) {
        const cutoff = text.match(/Bestellschluss.*?(\d{1,2}:\d{2})\s+Uhr/i)?.[1] || '10:00';
        if (text.startsWith('Einsatz 12:00–17:59 Uhr:')) {
          html = `<strong>Einsatz 12:00–17:59 Uhr:</strong> Expressversand bis 12:00 Uhr · ab 18:00 Uhr Expressversand bis 18:00 Uhr · Bestellschluss für Lieferung am nächsten regulären Zustelltag (außer Montag): ${cutoff} Uhr`;
        } else if (text.startsWith('Einsatz ab 18:00 Uhr:')) {
          html = `<strong>Einsatz ab 18:00 Uhr:</strong> Expressversand bis 18:00 Uhr · Bestellschluss für Lieferung am nächsten regulären Zustelltag (außer Montag): ${cutoff} Uhr`;
        }
      }

      if (html && guide.innerHTML !== html) guide.innerHTML = html;
    });

    root.querySelectorAll('[data-tpv20-next][title]').forEach(button => {
      const title = String(button.getAttribute('title') || '');
      const nextTitle = title.replace(
        /Abhol-Cutoff\s+(\d{1,2}:\d{2})\s+Uhr\s+überschritten/g,
        'Bestellschluss für Abholung am selben Tag ($1 Uhr) überschritten'
      );
      if (nextTitle !== title) button.setAttribute('title', nextTitle);
    });
  };

  const observeRoot = root => {
    if (!(root instanceof Element) || observedRoots.has(root)) return;
    observedRoots.add(root);
    patchRoot(root);
    new MutationObserver(() => patchRoot(root)).observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['title']
    });
  };

  const run = (scope = document) => {
    if (scope instanceof Element && scope.matches('[data-tpv20-root]')) observeRoot(scope);
    scope.querySelectorAll?.('[data-tpv20-root]').forEach(observeRoot);
  };

  run(document);
  document.addEventListener('shopify:section:load', event => run(event.target));
  window.addEventListener('pageshow', () => run(document));
})();

/* V20 Sparoption Variante B: Verlust, Kernbedarf und reduzierten Toleranzpuffer transparent ausweisen. */
(() => {
  'use strict';
  if (window.__tpv20RiskTransparencyB) return;
  window.__tpv20RiskTransparencyB = true;

  const observedRoots = new WeakSet();
  const queuedRoots = new WeakSet();
  const numberFromKg = value => {
    const match = String(value || '').match(/(-?\d+(?:[.,]\d+)?)\s*kg/i);
    return match ? Number(match[1].replace(',', '.')) : NaN;
  };
  const kg = value => {
    const num = Math.max(0, Number(value) || 0);
    const digits = Math.abs(num - Math.round(num)) < 0.001 ? 0 : 1;
    return `${num.toFixed(digits).replace('.', ',')} kg`;
  };
  const tolerancePercent = () => Math.round(Number(window.TPV20CentralConfig?.plannerToleranceRate ?? 0.05) * 1000) / 10;
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const setHtml = (node, value) => { if (node && node.innerHTML !== value) node.innerHTML = value; };

  const readRiskData = root => {
    const choice = root.querySelector('[data-tpv20-choice="risk"]');
    if (!choice) return null;
    const title = choice.querySelector('.tpv20-choice__title')?.textContent || '';
    const description = choice.querySelector('.tpv20-choice__desc')?.textContent || '';
    const values = Array.from(description.matchAll(/(\d+(?:[.,]\d+)?)\s*kg/gi)).map(match => Number(match[1].replace(',', '.')));
    const ordered = Number(choice.dataset.tpv20RiskOrdered || numberFromKg(title));
    const available = Number(choice.dataset.tpv20RiskAvailable || values[0]);
    const needed = Number(choice.dataset.tpv20RiskNeeded || values[1]);
    if (![ordered, available, needed].every(Number.isFinite)) return null;
    choice.dataset.tpv20RiskOrdered = String(ordered);
    choice.dataset.tpv20RiskAvailable = String(available);
    choice.dataset.tpv20RiskNeeded = String(needed);
    return {
      choice,
      ordered,
      available,
      needed,
      loss: Math.max(0, ordered - available),
      reserve: Math.max(0, available - needed),
      selected: choice.classList.contains('is-selected') || choice.getAttribute('aria-pressed') === 'true'
    };
  };

  const patchRiskChoice = data => {
    const pct = String(tolerancePercent()).replace('.', ',');
    setText(data.choice.querySelector('.tpv20-choice__badge'), 'Sparoption · knapp kalkuliert');
    setText(
      data.choice.querySelector('.tpv20-choice__desc'),
      `Nach erwartetem Lager- & Transportverlust stehen am Einsatztag voraussichtlich ${kg(data.available)} zur Verfügung. Dein Einsatzbedarf inkl. gewählter Sicherheitsreserve beträgt ${kg(data.needed)}. Der zusätzliche ${pct}-%-Toleranzpuffer ist nicht vollständig enthalten.`
    );
  };

  const patchFreshness = (root, data) => {
    const fresh = root.querySelector('[data-tpv20-freshness] .tpv20-fresh');
    if (!fresh) return;
    const pct = String(tolerancePercent()).replace('.', ',');
    fresh.dataset.state = 'warning';
    setText(fresh.querySelector(':scope > strong'), `${kg(data.available)} am Einsatz verfügbar`);
    const copy = `Einsatzbedarf inkl. gewählter Sicherheitsreserve: ${kg(data.needed)}. Erwarteter Lager- & Transportverlust aus der gewählten Bestellmenge: ${kg(data.loss)}. Verbleibende Reserve: ${kg(data.reserve)}. Der zusätzliche ${pct}-%-Toleranzpuffer ist nicht vollständig enthalten.`;
    setText(fresh.querySelector(':scope > p'), copy);
    setText(fresh.querySelector('.tpv20-mobile-compact__summary'), `• ${kg(data.available)} am Einsatz verfügbar · ${kg(data.reserve)} Reserve`);
    const mobileDetails = fresh.querySelector('.tpv20-mobile-details p');
    if (mobileDetails) setText(mobileDetails, copy);
  };

  const patchBreakdown = (root, data) => {
    const bridge = root.querySelector('[data-tpv20-breakdown] .tpv20-fresh-bridge');
    if (!bridge) return;
    const pct = String(tolerancePercent()).replace('.', ',');
    bridge.dataset.state = 'warning';
    setText(bridge.querySelector('.tpv20-fresh-title'), 'Sichere Planung vs. Sparoption');
    setText(bridge.querySelector('.tpv20-fresh-status'), 'Knapp · zusätzlicher Puffer reduziert');
    const steps = bridge.querySelectorAll('.tpv20-fresh-step');
    if (steps[0]) setText(steps[0].querySelector('span'), `Sichere Planung am Einsatz inkl. ${pct} % Toleranz`);
    if (steps[1]) setText(steps[1].querySelector('span'), '+ Lager- & Transportverlust · sichere Planung');
    if (steps[2]) setText(steps[2].querySelector('span'), '= Sichere benötigte Ausgangsmenge');
    setHtml(
      bridge.querySelector('.tpv20-fresh-summary'),
      `<strong>Sparoption:</strong> <strong>${kg(data.ordered)}</strong> bestellt → ca. <strong>${kg(data.loss)}</strong> Lager-/Transportverlust → ca. <strong>${kg(data.available)}</strong> am Einsatz verfügbar. Einsatzbedarf inkl. gewählter Sicherheitsreserve: <strong>${kg(data.needed)}</strong> → ca. <strong>${kg(data.reserve)}</strong> Restreserve. Zusätzlicher ${pct}-%-Toleranzpuffer nicht vollständig enthalten.`
    );

    root.querySelectorAll('[data-tpv20-scenarios] .tpv20-timeline-grid > div').forEach(item => {
      const label = item.querySelector('span');
      const value = item.querySelector('strong');
      const text = label?.textContent?.trim() || '';
      if (text === 'Am Einsatz benötigt') {
        setText(label, 'Einsatzbedarf inkl. Sicherheitsreserve');
        setText(value, kg(data.needed));
      } else if (text === 'Erwartete Restreserve') {
        setText(value, kg(data.reserve));
      }
    });
  };

  const patchRoot = root => {
    if (!(root instanceof Element)) return;
    const data = readRiskData(root);
    if (!data) return;
    patchRiskChoice(data);
    if (!data.selected) return;
    const choiceState = root.querySelector('[data-tpv20-choice-state]');
    setText(choiceState, 'Sparoption · knapp kalkuliert ist aktiv');
    patchFreshness(root, data);
    patchBreakdown(root, data);
  };

  const queuePatch = root => {
    if (!(root instanceof Element) || queuedRoots.has(root)) return;
    queuedRoots.add(root);
    queueMicrotask(() => {
      queuedRoots.delete(root);
      patchRoot(root);
    });
  };

  const observeRoot = root => {
    if (!(root instanceof Element) || observedRoots.has(root)) return;
    observedRoots.add(root);
    queuePatch(root);
    new MutationObserver(() => queuePatch(root)).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-pressed'] });
  };

  const run = (scope = document) => {
    if (scope instanceof Element && scope.matches('[data-tpv20-root]')) observeRoot(scope);
    scope.querySelectorAll?.('[data-tpv20-root]').forEach(observeRoot);
  };

  run(document);
  document.addEventListener('shopify:section:load', event => run(event.target));
  window.addEventListener('pageshow', () => run(document));
})();
